module.exports = __webpack_public_path__ + "static/media/arrow-left.59252414.svg";